import React, { createContext, useState } from "react";

export const AppContext = createContext();
const AppContextProvider = (props) => {
  const [activeTab, setActiveTab] = useState("profile");
  const [globalCategory, setGlobalCategory] = useState("Eloris");
  const values = {
    activeTab,
    setActiveTab,
    globalCategory,
    setGlobalCategory,
  };
  return (
    <AppContext.Provider value={values}>{props.children}</AppContext.Provider>
  );
};

export default AppContextProvider;
